import { Box } from '@mui/material';
import CreateOutlinedIcon from '@mui/icons-material/CreateOutlined';
import EditCourtLocationDialog from './modals/EditCourtLocationDialog';
import { refreshToken } from 'src/features/user/utils';
import { setCurrentUser } from 'src/features/user/userSlice';
import { editCourtLocation } from 'src/features/settings/utils';
import {
  clearErrors,
  loadData as CourtLocationLoadData,
  removeSuccessMsg,
  handleCourtLocationSubmit as validateCourtLocation,
} from 'src/features/settings/courtLocationSlice';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'src/store/store';
import { useEffect, useState } from 'react';
import { CurrentUser } from 'src/features/user/constants';
import BkSnackBar from 'src/components/snackbar/BkSnackBar';
import { Typography } from 'src/components/new/Typography';
import { Button } from 'src/components/new/Button';
import { Spacer } from 'src/components/new/Spacer';
interface DefaultCourtProps {
  currentUser: CurrentUser;
}

export const DefaultCourt = ({ currentUser }: DefaultCourtProps) => {
  const dispatch: AppDispatch = useDispatch();

  const formData = useSelector((state: RootState) => state.settings.courtLocation);

  const [isSubmitted, setIsSubmitted] = useState(false);

  const [showEditDialog, setShowEditDialog] = useState<boolean>(false);

  const [snackBarState, setSnackbarState] = useState<{
    message: string;
    isOpened: boolean;
    severity: 'error' | 'success' | 'info' | 'warning';
  }>({
    message: '',
    isOpened: false,
    severity: 'error',
  });

  const openCourtLocationDialog = () => {
    dispatch(CourtLocationLoadData({ ...currentUser.courtLocation }));
    dispatch(removeSuccessMsg());
    dispatch(clearErrors());
    setShowEditDialog(true);
  };

  const handleCourtLocationSubmit = () => {
    dispatch(validateCourtLocation());
    setIsSubmitted(true);
  };

  useEffect(() => {
    if (Object.values(formData.formDataErrors).some((error) => error)) {
      setIsSubmitted(false);
    }

    if (isSubmitted && !Object.values(formData.formDataErrors).some((error) => error)) {
      setIsSubmitted(false);
      dispatch(editCourtLocation(formData.formData)).then((response) => {
        closeCourtLocationDialog();
        if (response.meta.requestStatus !== 'rejected') {
          dispatch(
            setCurrentUser({
              user: {
                ...currentUser,
                courtLocation: formData.formData,
              },
              accessToken: currentUser.accessToken,
            }),
          );
          dispatch(refreshToken());
          setSnackbarState({
            ...snackBarState,
            isOpened: true,
            message: 'Successfully updated court location!',
            severity: 'success',
          });
        } else {
          setSnackbarState({
            ...snackBarState,
            isOpened: true,
            message: 'Error occured during court location update',
            severity: 'error',
          });
        }
      });
    }
  }, [formData.formDataErrors, isSubmitted, dispatch]);

  const closeCourtLocationDialog = () => {
    setShowEditDialog(false);
  };

  return (
    <Box sx={{ padding: '2.5rem 1.5rem' }}>
      <Typography sx={{ fontSize: '2rem', lineHeight: '2.5rem' }} fontWeight={400}>
        Local Court
      </Typography>
      <div style={{ display: 'flex', gap: '8rem', marginTop: '1.5rem' }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem', minWidth: '17.5rem' }}>
          <Typography fontWeight={400} sx={{ fontSize: '0.875rem', lineHeight: '1.25rem' }}>
            State
          </Typography>
          <Typography fontWeight={500} sx={{ fontSize: '1.375rem', lineHeight: '1.75rem' }}>
            {currentUser?.courtLocation ? currentUser.courtLocation.state : '-'}
          </Typography>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem', minWidth: '17.5rem' }}>
          <Typography fontWeight={400} sx={{ fontSize: '0.875rem', lineHeight: '1.25rem' }}>
            District
          </Typography>
          <Typography fontWeight={500} sx={{ fontSize: '1.375rem', lineHeight: '1.75rem' }}>
            {currentUser?.courtLocation ? currentUser.courtLocation.district || '-' : '-'}
          </Typography>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem', minWidth: '17.5rem' }}>
          <Typography fontWeight={400} sx={{ fontSize: '0.875rem', lineHeight: '1.25rem' }}>
            Division
          </Typography>
          <Typography fontWeight={500} sx={{ fontSize: '1.375rem', lineHeight: '1.75rem' }}>
            {currentUser?.courtLocation ? currentUser.courtLocation.division : '-'}
          </Typography>
        </div>
      </div>
      <Box sx={{ maxWidth: '25rem', marginTop: '1.5rem' }}>
        <Button type="outline" onClick={() => openCourtLocationDialog()}>
          <CreateOutlinedIcon />
          <Spacer w={8} />
          Edit Court
        </Button>
      </Box>
      {showEditDialog && (
        <EditCourtLocationDialog
          open={showEditDialog}
          onClose={closeCourtLocationDialog}
          onSubmit={handleCourtLocationSubmit}
        />
      )}
      <BkSnackBar
        open={snackBarState.isOpened}
        handleCloseSnackbar={() => setSnackbarState({ ...snackBarState, isOpened: false })}
        snackMessage={snackBarState.message}
        severity={snackBarState.severity}
      />
    </Box>
  );
};
